import { Injectable } from '@angular/core';
import { Router, NavigationEnd, Event, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

@Injectable({
    providedIn: "root"
})
export class BackButtonService {
    private previousUrlMapper = new Map<string, string>();
    private _previousUrl: string;
    private _backUrl: boolean;

    public get previousUrl(): string {
        return this.previousUrlMapper.get(this.router.url);
    }

    constructor(
        private router: Router,
    ) {
        this.router.events
            .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
            .subscribe((events: RoutesRecognized[]) => {
                this._previousUrl = events[0].urlAfterRedirects;
                let afterUrl = events[1].urlAfterRedirects;

                if (!this._backUrl && this.previousUrlMapper.get(afterUrl) && this._previousUrl != undefined) {
                    this.previousUrlMapper.set(afterUrl, this._previousUrl);
                }

                this._backUrl = false;
            });
    }

    setPreviousUrl() {
        if (!this.previousUrlMapper.has(this.router.url) && this._previousUrl != undefined) {
            this.previousUrlMapper.set(this.router.url, this._previousUrl);
        }
    }


    goBack() {
        this._backUrl = true;
        if (this._previousUrl) {
            this.router.navigate([this.previousUrlMapper.get(this.router.url)]);
        }
    }

}
